<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Consultas — Documentos: Por irregularidade
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta consulta lista documentos filtrando por
        strong  modelo
        |  e
        strong  irregularidade
        | , além dos demais critérios habituais.

      .toast.toast-primary
        | Exige a permissão
        strong  Consulta → Documentos → Por irregularidade → Listar
        | .

      h5.h5 1. Abrir Por Irregularidade
      ol
        li Em
          strong  Consultas → Documentos
          | , clique em
          strong  Por Irregularidade
          | .

      h5.h5 2. Filtrar por modelo e irregularidade
      ol
        li Selecione o
          strong  Modelo
          |  do documento.
        li Em
          strong  Irregularidades
          | , escolha um código/descrição ou deixe
          em Todas
          | .
        li Preencha número, ano, cadastro e demais filtros se quiser.
        li Clique na
          strong  lupa
          |  para aplicar.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem Documentos por irregularidade")
      p
        | A tabela mostra número/ano, modelo, lista de irregularidades,
        |  cadastro, ciência, situação e valor total.

      h5.h5 3. Exibir ou imprimir
      ol
        li Clique no ícone de
          strong  olho
          |  para abrir o documento na Fiscalização (tela de Doc).
        li Clique no ícone de
          strong  impressora
          |  para abrir o PDF em nova aba.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/23-consultas-docs-por-irregularidade-lista.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
